/** Traductions page POS / Dashboard vente (FR / AR) */
import { barcodeScanSharedFr, barcodeScanSharedAr } from './barcodeScanShared';

export const posDashboardFr = {
  errInsufficientLotQty: '{{product}}: Quantité demandée supérieure à la quantité disponible dans le lot',
  errExpiredLot: '{{product}}: Lot expiré',
  errLotNotFound: '{{product}}: Lot non trouvé',
  errProductDetail: '{{product}}: {{details}}',
  importSuccessTitle: 'Import réussi',
  importSuccessMessage: '{{count}} produits importés avec succès',
  errProductNotInStock: 'Produit non disponible en stock',
  errQtyExceedsStock: 'Quantité demandée ({{requested}}) dépasse le stock disponible ({{available}})',
  errPackSellNotConfigured: 'Prix carton non configuré pour ce produit',
  packSellTitle: 'Mode de vente',
  packSellHint: 'Choisir l’unité ou le carton — prix différents',
  packSellUnit: 'Unité',
  packSellUnitMeta: '1 pièce',
  packSellCarton: 'Carton ({{count}})',
  packSellCartonMeta: '{{count}} unités · stock',
  packSellCancel: 'Annuler',
  errBarcodeUnknown: barcodeScanSharedFr.unknown,
  errBarcodeNotFound: barcodeScanSharedFr.notFound,
  errBarcodeOutOfStockTitle: barcodeScanSharedFr.outOfStockTitle,
  errBarcodeOutOfStock: barcodeScanSharedFr.outOfStock,
  errBarcodeNoCatalog: barcodeScanSharedFr.noCatalog,
  errBarcodeAmbiguous: barcodeScanSharedFr.ambiguous,
  errBarcodeAmbiguousDetail: barcodeScanSharedFr.ambiguousDetail,
  added: 'Ajouté',
  errEmptyDraft: 'Impossible de sauvegarder un brouillon vide',
  draftSaved: 'Sauvegardé',
  draftSavedSuccess: 'Brouillon sauvegardé avec succès',
  deliveryDraftSaved: 'Livraison',
  deliveryDraftSavedSuccess: 'Vente livraison enregistrée (brouillon)',
  deliveryReadyTitle: 'Livré',
  deliveryReadySuccess: 'Paiement prêt — encaisser comme une vente normale',
  errEmptyCart: 'Panier vide',
  errEmptyCartDetail: 'Ajoutez des produits avant de finaliser la vente',
  errEnterCashAmount: 'Veuillez entrer le montant payé',
  errCreditNeedsCustomer: 'Vente à crédit',
  errCreditNeedsCustomerDetail:
    'Saisissez ou sélectionnez un client sur le reçu (ou créez-en un nouveau)',
  errCreditDepositInvalid: 'L’acompte ne peut pas être négatif',
  errCreditDepositTooHigh: 'L’acompte ne peut pas dépasser le total',
  errCreditDepositNeedsElectronic: 'Choisissez un moyen de paiement électronique pour l’acompte',
  errSelectElectronicProvider: 'Choisissez un fournisseur de paiement électronique (Bankily, Sedad…)',
  errCreditLimitExceeded: 'Limite de crédit dépassée',
  errCreditLimitExceededDetail:
    'Disponible {{available}} (limite {{limit}}, déjà dû {{used}}). Réduisez le panier ou choisissez un autre paiement.',
  creditCapacityAvailable: 'Crédit dispo. {{available}} / limite {{limit}}',
  creditCapacityNearLimit: 'Proche de la limite (utilisé {{used}} / {{limit}})',
  errInsufficientCash: 'Le montant payé ({{paid}}) est inférieur au total ({{total}}). Montant manquant: {{difference}}',
  errCheckoutGeneric: 'Une erreur est survenue lors du traitement de la vente',
  errCheckoutTitle: 'Erreur lors de la finalisation',
  errValidationTitle: 'Erreur de validation',
  errStockTitle: 'Erreur de stock',
  errDishNoRecipeTitle: 'Recette requise',
  errDishNoRecipe:
    '{{product}} : activez une recette (ou composition stock) avant la vente — pas d’abonnement lot sans recette',
  errPaymentTitle: 'Erreur de paiement',
  cartCleared: 'Panier vidé',
  errPosDataLoadingTitle: 'Veuillez patienter',
  errPosDataLoading: 'Chargement des données de vente — veuillez patienter',
  errPosSecurityLoading: 'Vérification de sécurité en cours — veuillez patienter',
  tableTicketSaved: 'Enregistré',
  tableTicketSavedSuccess: 'Commande table enregistrée',
  tableTicketCancelled: 'Annulé',
  tableTicketCancelledSuccess: 'Ticket table annulé',
  kitchenSent: 'Cuisine',
  kitchenSentSuccess: '{{count}} ligne(s) envoyée(s)',
  kitchenSentParked: '{{count}} ligne(s) envoyée(s) — panier vidé, en attente cuisine',
  kitchenNothingToSend: 'Cuisine',
  kitchenNothingToSendDetail: 'Rien de nouveau à envoyer',
  kitchenReadyTitle: 'Cuisine',
  kitchenReadyPay: '{{label}} prêt — encaisser maintenant',
  kitchenServedPay: '{{label}} servi — encaisser maintenant',
  kitchenReadyBannerTitle: 'COMMANDE PRÊTE',
  kitchenServedBannerTitle: 'COMMANDE SERVIE',
  kitchenReadyBannerEmporter:
    'Emporter prêt — ouvrez « Commandes cuisine » (à côté des brouillons) pour encaisser',
  kitchenReadyBannerTable:
    'Table {{label}} prête — ouvrez « Commandes cuisine » pour encaisser',
  kitchenNotReadyTitle: 'Cuisine',
  kitchenNotReadyDetail: 'Pas encore prêt à encaisser',
  kitchenCheckoutAwaiting: 'En cuisine — paiement après Prêt / Servi',
  kitchenCheckoutSendFirst: 'Envoyez à la cuisine d’abord — paiement après Prêt',
  kitchenLoadedForPay: 'Caisse',
  kitchenLoadedForPayDetail: 'Commande chargée — encaisser',
  additionPrinted: 'Addition',
  additionPrintedSuccess: 'Addition imprimée — à régler (non payée)',
  printAddition: "Imprimer l'addition",
  printAdditionEmpty: 'Aucune ligne à imprimer',
  storeLabel: 'Magasin',
  storeTitle: 'Magasin de vente (stock)',
  storeSwitched: 'Magasin actif : {{name}}',
  storeSwitchedCartCleared: 'Magasin changé — panier vidé pour éviter un stock croisé',
  storeSwitchFailed: 'Impossible de changer le magasin'
};

export const posDashboardAr = {
  errInsufficientLotQty: '{{product}}: الكمية المطلوبة أكبر من الكمية المتاحة في الدفعة',
  errExpiredLot: '{{product}}: الدفعة منتهية الصلاحية',
  errLotNotFound: '{{product}}: لم يتم العثور على الدفعة',
  errProductDetail: '{{product}}: {{details}}',
  importSuccessTitle: 'تم الاستيراد بنجاح',
  importSuccessMessage: 'تم استيراد {{count}} منتج بنجاح',
  errProductNotInStock: 'المنتج غير متوفر في المخزون',
  errQtyExceedsStock: 'الكمية المطلوبة ({{requested}}) تتجاوز المخزون المتاح ({{available}})',
  errPackSellNotConfigured: 'سعر الكرتون غير مضبوط لهذا المنتج',
  packSellTitle: 'طريقة البيع',
  packSellHint: 'اختر الوحدة أو الكرتون — أسعار مختلفة',
  packSellUnit: 'وحدة',
  packSellUnitMeta: 'قطعة واحدة',
  packSellCarton: 'كرتون ({{count}})',
  packSellCartonMeta: '{{count}} وحدات · مخزون',
  packSellCancel: 'إلغاء',
  errBarcodeUnknown: barcodeScanSharedAr.unknown,
  errBarcodeNotFound: barcodeScanSharedAr.notFound,
  errBarcodeOutOfStockTitle: barcodeScanSharedAr.outOfStockTitle,
  errBarcodeOutOfStock: barcodeScanSharedAr.outOfStock,
  errBarcodeNoCatalog: barcodeScanSharedAr.noCatalog,
  errBarcodeAmbiguous: barcodeScanSharedAr.ambiguous,
  errBarcodeAmbiguousDetail: barcodeScanSharedAr.ambiguousDetail,
  added: 'تمت الإضافة',
  errEmptyDraft: 'لا يمكن حفظ مسودة فارغة',
  draftSaved: 'تم الحفظ',
  draftSavedSuccess: 'تم حفظ المسودة بنجاح',
  deliveryDraftSaved: 'توصيل',
  deliveryDraftSavedSuccess: 'تم تسجيل بيع التوصيل (مسودة)',
  deliveryReadyTitle: 'تم التوصيل',
  deliveryReadySuccess: 'الدفع جاهز — أتمّ البيع كالمعتاد',
  errEmptyCart: 'السلة فارغة',
  errEmptyCartDetail: 'أضف منتجات قبل إتمام البيع',
  errEnterCashAmount: 'يرجى إدخال المبلغ المدفوع',
  errCreditNeedsCustomer: 'بيع آجل',
  errCreditNeedsCustomerDetail:
    'أدخل أو اختر عميلاً على الإيصال (أو أنشئ عميلاً جديداً)',
  errCreditDepositInvalid: 'لا يمكن أن تكون الدفعة سالبة',
  errCreditDepositTooHigh: 'لا يمكن أن تتجاوز الدفعة الإجمالي',
  errCreditDepositNeedsElectronic: 'اختر وسيلة دفع إلكترونية للدفعة',
  errSelectElectronicProvider: 'اختر مزود الدفع الإلكتروني (Bankily، Sedad…)',
  errCreditLimitExceeded: 'تم تجاوز حد الائتمان',
  errCreditLimitExceededDetail:
    'المتاح {{available}} (الحد {{limit}}، المستحق {{used}}). قلّل السلة أو اختر طريقة دفع أخرى.',
  creditCapacityAvailable: 'الائتمان المتاح {{available}} / الحد {{limit}}',
  creditCapacityNearLimit: 'قرب الحد (المستخدم {{used}} / {{limit}})',
  errInsufficientCash: 'المبلغ المدفوع ({{paid}}) أقل من المجموع الكلي ({{total}}). المبلغ الناقص: {{difference}}',
  errCheckoutGeneric: 'حدث خطأ أثناء معالجة البيع',
  errCheckoutTitle: 'خطأ في إتمام البيع',
  errValidationTitle: 'خطأ في التحقق',
  errStockTitle: 'خطأ في المخزون',
  errDishNoRecipeTitle: 'وصفة مطلوبة',
  errDishNoRecipe:
    '{{product}}: فعّل وصفة نشطة (أو مكوّنات مخزون) قبل البيع — لا خصم lot بدون وصفة',
  errPaymentTitle: 'خطأ في الدفع',
  cartCleared: 'تم مسح السلة',
  errPosDataLoadingTitle: 'يرجى الانتظار',
  errPosDataLoading: 'جاري تحميل بيانات المبيعات — انتظر لحظة',
  errPosSecurityLoading: 'جاري التحقق من الأمان — انتظر لحظة',
  tableTicketSaved: 'تم الحفظ',
  tableTicketSavedSuccess: 'تم حفظ طلب الطاولة',
  tableTicketCancelled: 'ملغى',
  tableTicketCancelledSuccess: 'تم إلغاء تذكرة الطاولة',
  kitchenSent: 'المطبخ',
  kitchenSentSuccess: 'تم إرسال {{count}} بند',
  kitchenSentParked: 'تم إرسال {{count}} بند — السلة فارغة، بانتظار المطبخ',
  kitchenNothingToSend: 'المطبخ',
  kitchenNothingToSendDetail: 'لا جديد لإرساله',
  kitchenReadyTitle: 'المطبخ',
  kitchenReadyPay: '{{label}} جاهز — حصّل الآن',
  kitchenServedPay: '{{label}} تم التقديم — حصّل الآن',
  kitchenReadyBannerTitle: 'الطلب جاهز',
  kitchenServedBannerTitle: 'تم تقديم الطلب',
  kitchenReadyBannerEmporter:
    'للأخذ جاهز — افتح «طلبات المطبخ» (بجانب المسودات) للتحصيل',
  kitchenReadyBannerTable:
    'طاولة {{label}} جاهزة — افتح «طلبات المطبخ» للتحصيل',
  kitchenNotReadyTitle: 'المطبخ',
  kitchenNotReadyDetail: 'ليس جاهزاً للتحصيل بعد',
  kitchenCheckoutAwaiting: 'في المطبخ — الدفع بعد جاهز / تم التقديم',
  kitchenCheckoutSendFirst: 'أرسل للمطبخ أولاً — الدفع بعد جاهز',
  kitchenLoadedForPay: 'الصندوق',
  kitchenLoadedForPayDetail: 'تم تحميل الطلب — حصّل',
  additionPrinted: 'الفاتورة',
  additionPrintedSuccess: 'تمت طباعة الفاتورة — غير مدفوعة',
  printAddition: 'طباعة الفاتورة',
  printAdditionEmpty: 'لا توجد بنود للطباعة',
  storeLabel: 'المتجر',
  storeTitle: 'متجر البيع (المخزون)',
  storeSwitched: 'المتجر النشط: {{name}}',
  storeSwitchedCartCleared: 'تم تغيير المتجر — أفرغت السلة لتجنب مخزون مختلط',
  storeSwitchFailed: 'تعذّر تغيير المتجر'
};
